module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-tabbed-vehicle-reports"
  }, [_c('div', {
    staticClass: "action-bar"
  }, [_vm._m(0), _c('div', {
    staticClass: "action"
  }, [_c('reporting-list-form', {
    attrs: {
      "type": 'entity-filter'
    },
    on: {
      "filterReportings": _vm.applyFilters
    }
  }), _c('router-link', {
    attrs: {
      "to": {
        name: 'create-reporting',
        params: {
          vehicleId: _vm.$route.params.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-2x",
    attrs: {
      "data-toggle": "create-card"
    }
  })])], 1)]), _c('div', {
    staticClass: "tabs-inner-content"
  }, [(_vm.damagePositions) ? _c('vehicle-damage-detail', {
    ref: "vehicleDamage",
    attrs: {
      "items": _vm.damagePositions,
      "vehicle-damage-picture": _vm.item.category.damage_picture_external
    }
  }) : _vm._e(), _c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "search": _vm.search
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Reports")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-576c3b6f!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/VehicleReports.vue
// module id = 2517
// module chunks = 1